module.exports = __webpack_public_path__ + "img/park-avenue-south_b1.acd35182.jpg";